export function cssStyleSheetLoader() {
    function loadCssStyleSheet(url) {
        if (document.querySelector(`link[data-vue-dynamic-css="${url}"]`)) {
            return;
        }
        // Neues Stylesheet als <link> in den <head> einfügen
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = url;
        link.setAttribute("data-vue-dynamic-css", url); // Zur Identifikation
        document.head.appendChild(link);
    }
    return {
        loadCssStyleSheet
    };
}
